// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useContext, useState, useEffect, useRef, useLayoutEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import CommonContext from '../../../contexts/CommonContext';
import S from './style';
import { getMultilang } from '../../../components/common/Multilang';
import ErrorImg from '../../../assets/images/pic_error_internet.svg';
import TickIcon from '../../../assets/images/tick-icon-green.svg';
import CloseIcon from '../assets/close.svg';
import ManagerMessage from './ManagerMessage'
import UserMessage from './UserMessage'
import { Link, useHistory } from 'react-router-dom';
import { SupportReply, SupportStateType, SupportType } from '../../../types/Model';
import Popup from './Popup'
import DragField from '../DragField';

interface ChatFormProps {
  data: SupportReply[];
  currentId: number;
  username: string;
  replySupport: (id: number, message: string, imagesFiles: File[]) => void;
  updateSupportStatus: (id: number) => void;
  isReplying: boolean;
  supportType: SupportType;
  problemTitle: string;
  problemStatus: SupportStateType;
}
interface ImageUpload {
  urls: string;
  file: File;
}
const ChatForm = (props: ChatFormProps): JSX.Element => {
  const intl = useIntl();
  const common = useContext(CommonContext);
  const history = useHistory();
  const { data, username, replySupport, currentId, isReplying, supportType, problemTitle, problemStatus, updateSupportStatus } = props;
  const [isError, setIsError] = useState<boolean>(false);
  const [listImagePreviewUrls, setListImagePreviewUrl] = useState<ImageUpload[]>([]);
  const [scrollState, setScrollState] = useState<number>(0);
  const [inputMessage, setInputMessage] = useState<string>('')
  const [isStatusClosed, setIsStatusClosed] = useState<boolean>(false)
  const [displayDragField, setDisplayDragField] = useState<boolean>(false);
  const [showPreview, setShowPreview] = useState<{
    time: string;
    message: string;
    username: string;
    imagesUrls: string[];
    currentPhotoId: number;
  }>()
  const supportTypes = common.supportTypes.map(supportTypes => ({
    id: supportTypes as SupportType,
    label: intl.formatMessage({ id: supportTypes }) || '',
    value: supportTypes
  })).filter(supportTypes => supportTypes.id === supportType)[0]
  const chatFieldRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!chatFieldRef.current) return;
    console.log(chatFieldRef.current.scrollHeight)
    chatFieldRef.current.scrollTop = chatFieldRef.current.scrollHeight;
  }, [currentId, data])
  useEffect(() => {
    if (problemStatus === SupportStateType.Closed) {
      setIsStatusClosed(true);
    } else {
      setIsStatusClosed(false);
    }
  }, [problemStatus])

  useEffect(() => {
    console.log(isReplying)
    if (!isReplying) {
      setInputMessage('');
      setListImagePreviewUrl([]);
    }
  }, [isReplying, currentId])

  useLayoutEffect(() => {
    if (!chatFieldRef.current) return;
    chatFieldRef.current.scrollTop = scrollState;
  }, [inputMessage]);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value;
    setInputMessage(value);
  }
  const handleScroll = (e: any) => {
    const event = e.target;
    setScrollState(event.scrollTop)
  }
  const sendReply = () => {
    console.log(listImagePreviewUrls.map(data => data.file))
    replySupport(currentId, inputMessage, listImagePreviewUrls.map(data => data.file))
  }
  const closeChatForm = () => {
    history.push('/support');
  }
  const dragOver = (e: any) => {
    e.preventDefault();
    // setDisplayDragField(false)
  }

  const dragEnter = (e: any) => {
    e.preventDefault();
    setDisplayDragField(true)
  }

  const dragLeave = (e: any) => {
    e.preventDefault();
    // setDisplayDragField(false)
  }

  const imagePreview = (file: File) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const url = reader.result as string;
      setListImagePreviewUrl(data => [...data, { urls: url, file }])
    };
  }
  const fileDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    if (e.dataTransfer) {
      const files = e.dataTransfer.files;
      for (let i = 0; i < files.length; i++) {
        imagePreview(files[i])
      }
    }
    setDisplayDragField(false)
    // console.log(files);
  }

  console.log({ data })
  if (isError) {
    return (
      <S.Container {...props}>
        <S.Image src={ErrorImg} style={{ width: '110px', height: '110px' }} />
        <S.TitleText >
          發問失敗
        </S.TitleText>
        <S.DescriptionText style={{ maxWidth: '306px' }}>
          好像哪裡出錯了，請點此 {<S.Resend onClick={() => window.location.reload()}>重試</S.Resend>}。 {'\n'} 如還是無法解決，請返回首頁稍後再試
        </S.DescriptionText>
        <S.ButtonBackDefault as={Link} to={'/home'}>
          返回首頁
        </S.ButtonBackDefault>
      </S.Container>
    )
  }

  return (
    <S.ChatFieldWrapper {...props}>
      {showPreview && <Popup {...showPreview} setShowPreview={setShowPreview} />}
      <S.HeaderWrapper>
        <S.HeaderTextWrapper>
          <S.HeaderSupportCatagory >{supportTypes.label}{isStatusClosed ? (
            <S.Tag>
              <S.Image src={TickIcon} style={{ height: '15px', width: '15px', marginLeft: '28px', marginRight: '6px' }} />
              <FormattedMessage id="E024" />
            </S.Tag>
          ) : ''}</S.HeaderSupportCatagory>
          <S.HeaderSupportTitle >{problemTitle}</S.HeaderSupportTitle>
        </S.HeaderTextWrapper>
        <S.Image style={{ height: '20px', width: '20px', marginLeft: 'auto', cursor: 'pointer' }} src={CloseIcon} onClick={closeChatForm} />
      </S.HeaderWrapper>
      <S.Wrapper
        onDragOver={dragOver}
        onDragEnter={dragEnter}
        onDragLeave={dragLeave}
        onDrop={fileDrop}
      >
        {displayDragField && <DragField />}
        <S.ChatWrapper>
          <S.ChatField
            ref={chatFieldRef}
            onScroll={handleScroll}>
            {data.map(replyData => {
              const createdTime = new Date(replyData.createdTime);
              if (replyData.username === username) {
                return (
                  <UserMessage
                    key={replyData.id}
                    time={createdTime}
                    username={replyData.username}
                    message={replyData.message}
                    imagesUrls={replyData.imagesUrls}
                    setShowPreview={setShowPreview}
                  />)
              }
              return (
                <ManagerMessage
                  key={replyData.id}
                  time={createdTime}
                  username={replyData.username}
                  message={replyData.message}
                  imagesUrls={replyData.imagesUrls}
                  currentId={currentId}
                  updateSupportStatus={updateSupportStatus}
                  messageType={replyData.messageType}
                  isStatusClosed={isStatusClosed}
                  setShowPreview={setShowPreview}
                />)
            })}
          </S.ChatField>

          <S.ReplyField
            message={inputMessage}
            onChange={handleChange}
            isLoading={isReplying}
            placeholder={intl.formatMessage({ id: 'I021' })}
            listImagePreviewUrls={listImagePreviewUrls}
            setListImagePreviewUrl={setListImagePreviewUrl}
            disabled={inputMessage === '' && listImagePreviewUrls.length === 0}
            onSubmit={sendReply}
            inline={true}
          />
        </S.ChatWrapper>
      </S.Wrapper>
    </S.ChatFieldWrapper>
  );
}

export { ChatForm as default }
